import { createStyles, makeStyles } from "@material-ui/core";
import {
    CheckIcon,
    FeedbackButtons,
    PageActionButton,
    TimesIcon,
} from "@relode/core";
import { JobCandidateStatus } from "@relode/core/domain";
import * as React from "react";

import { useCandidateContext } from "../../../_infra";
import { CandidateActionsProps } from "./candidateActionsProps";

const useStyles = makeStyles(
    () =>
        createStyles({
            root: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1,
            },
        }),
    { name: "CandidateActionsMobile" }
);

export const CandidateActionsMobile = (props: CandidateActionsProps) => {
    const classes = useStyles({});
    const {
        feedbackDetails,
        onFeedbackClick,
        selectedVote,
        canViewReject,
        onRejectClick,
        canViewPositiveAction,
        onPositiveActionClick,
    } = props;

    const {
        state: {
            data: { candidate },
        },
    } = useCandidateContext();

    const { actions } = candidate;

    const status = candidate.highlights
        ? JobCandidateStatus.fromId(candidate.highlights.candidateStatusId)
        : undefined;

    return (
        <div className={classes.root}>
            <div>
                {canViewReject ? (
                    <PageActionButton
                        id="rejectCandidateButton"
                        actionType="negative"
                        title="reject"
                        disabled={status.id === JobCandidateStatus.Rejected.id}
                        onClick={onRejectClick}
                    >
                        <TimesIcon />
                    </PageActionButton>
                ) : null}
            </div>
            <div>
                {feedbackDetails.canGiveFeedback ||
                feedbackDetails.canViewFeedback ? (
                    <FeedbackButtons
                        onClick={onFeedbackClick}
                        selectedFeedbackType={selectedVote}
                        showFeedbackCounts={feedbackDetails.canViewFeedback}
                        upCount={feedbackDetails.upVotesCount}
                        downCount={feedbackDetails.downVotesCount}
                    />
                ) : null}
            </div>
            <div>
                {canViewPositiveAction ? (
                    <PageActionButton
                        id="positiveActionCandidateButton"
                        actionType="positive"
                        title={actions.positiveCandidateStatusActionName}
                        onClick={() =>
                            onPositiveActionClick(
                                actions.positiveCandidateStatusActionName
                            )
                        }
                    >
                        <CheckIcon />
                    </PageActionButton>
                ) : null}
            </div>
        </div>
    );
};
